import React from "react";
import getEnv from "@/utils/getEnv";
import { useTranslation } from "react-i18next";

export default function DepositItems() {
  const { t } = useTranslation();

  const items = [
    {
      title: t("components.checkDepositModal.depositItems.budgetStoredTitle"),
      desc: t("components.checkDepositModal.depositItems.budgetStoredDesc"),
    },
    {
      title: t("components.checkDepositModal.depositItems.lockReleaseTitle"),
      desc: t("components.checkDepositModal.depositItems.lockReleaseDesc"),
    },
    {
      title: t(
        "components.checkDepositModal.depositItems.flexibleRefundsTitle"
      ),
      desc: t("components.checkDepositModal.depositItems.flexibleRefundsDesc"),
      linkText: t(
        "components.checkDepositModal.depositItems.flexibleRefundsLink"
      ),
      link:
        getEnv() === "development"
          ? "https://test.ahacreator.com/terms-of-service?jump_source=deposit"
          : "https://www.ahacreator.com/terms-of-service?jump_source=deposit",
    },
    {
      title: t(
        "components.checkDepositModal.depositItems.escrowProtectionTitle"
      ),
      desc: t("components.checkDepositModal.depositItems.escrowProtectionDesc"),
    },
  ];

  return (
    <div className="w-full mt-6 flex flex-wrap gap-4">
      {items.map((item) => (
        <div
          className="flex flex-col gap-1 p-4 bg-[#F5F5F4] rounded-lg"
          style={{
            width: `calc((100% / 2 - 8px)`,
          }}
        >
          <div className="min-h-6 justify-center text-font&icon-primary text-base font-semibold font-['DM_Sans'] leading-normal">
            {item.title}
          </div>
          <div className="justify-center">
            <span className="text-font&icon-secondary text-xs font-normal font-['DM_Sans'] leading-none">
              {item.desc}{" "}
            </span>
            {item.linkText && (
              <a
                href={item.link}
                target="_blank"
                className="text-font&icon-link text-xs font-normal font-['DM_Sans'] leading-none" rel="noreferrer"
              >
                {item.linkText}
              </a>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
